import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { NoteProps } from './types';
import { toDocumentWithEmbeddedEntries } from 'libs/contentful/toDocumentWithEmbeddedEntries';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn, getColorway, getYMarginsSlim } from 'utils/styles';

const Note = (props: NoteProps) => {
  const { color, headline, copy, margins } = props.fields;

  const headlineDoc = toDocumentWithEmbeddedEntries(headline, { parentTypename: 'Note', fieldName: 'headline' });
  const copyDoc = toDocumentWithEmbeddedEntries(copy, { parentTypename: 'Note', fieldName: 'copy' });

  return (
    <section className={cn(getColorway(color), getYMarginsSlim(margins))} data-testid="note">
      <div className="content-wrapper">
        <div className="border border-(--keyline-color) rounded-lg p-8 sm:py-12 sm:px-16 space-y-4">
          <div
            {...liveUpdateAttrs(props.sys.id, 'headline')}
            data-testid="noteHeadline"
            className="font-sans text-2xl font-semibold">
            <RichTextHeadline headline={headlineDoc} />
          </div>
          <div {...liveUpdateAttrs(props.sys.id, 'copy')} data-testid="noteCopy" className="font-serif text-body-serif">
            <RichTextCopy copy={copyDoc} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Note;
